module.exports = __webpack_public_path__ + "media/Diagnose Ninon_neu_Stufe02.3253d33b.mp4";